import React, { useState, useRef, useEffect } from 'react';

const DisplayPreview = ({ sessionId, isVisible, onToggle }) => {
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef(null);
  
  // Generate the display view URL
  const displayUrl = `/display/${sessionId}`;
  
  // Handle iframe load
  const handleIframeLoad = () => {
    setIsLoading(false);
  };
  
  // Reset loading state when visibility changes
  useEffect(() => {
    if (isVisible) {
      setIsLoading(true);
    }
  }, [isVisible]);
  
  return (
    <>
      {/* Toggle Button */}
      <button
        onClick={onToggle}
        className={`fixed bottom-32 right-4 z-50 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg transition-all duration-200 ${
          isVisible ? 'bg-blue-700' : 'bg-blue-600'
        }`}
        title={isVisible ? 'Hide Display Preview' : 'Show Display Preview'}
      >
        {isVisible ? (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        )}
      </button>

      {/* Preview Panel */}
      {isVisible && (
        <div className="fixed bottom-24 right-16 z-40 bg-white rounded-lg shadow-2xl border border-gray-200 w-80 h-45">
          {/* Header */}
          <div className="flex items-center justify-between p-2 bg-gray-50 rounded-t-lg border-b border-gray-200">
            <span className="text-sm font-medium text-gray-700">Display Preview</span>
            <button
              onClick={() => window.open(displayUrl, '_blank')}
              className="p-1 hover:bg-gray-200 rounded transition-colors"
              title="Open in new tab"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </button>
          </div>

          {/* Iframe Content - 16:9 aspect ratio (1920x1080 scaled down) */}
          <div className="relative w-full bg-gray-100 rounded-b-lg overflow-hidden" style={{ aspectRatio: '16/9' }}>
            <div className="relative w-full h-full overflow-hidden">
              <iframe
                ref={iframeRef}
                src={displayUrl}
                className="border-0"
                title="Display Preview"
                onLoad={handleIframeLoad}
                loading="lazy"
                style={{ 
                  width: '1920px', 
                  height: '1080px',
                  transform: 'scale(0.2)',
                  transformOrigin: 'top left'
                }}
              />
            </div>
            {/* Loading overlay */}
            {isLoading && (
              <div className="absolute inset-0 bg-gray-100 flex items-center justify-center">
                <div className="text-gray-500 text-sm">Loading preview...</div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default DisplayPreview;
